module.exports = __webpack_public_path__ + "img/nav-icon-2.9f07347c.svg";